export default "__VITE_ASSET__CJmebyfy__"